import * as actionType from "./types";
import axios from "../../../common/config/axios";

export const getTotalDepositedAmount = () => (dispatch, getState) => {
  axios
    .get("marathon_challenge_event/total_deposited_amount")
    .then(function (response) {
      dispatch({
        type: actionType.GET_TOTAL_DEPOSITED_AMOUNT,
        value: response.data,
      });
    })
    .catch((err) => {
      console.error(err);
    });
};
